
import '../../styles/style.css'

const HCI = () => {
    return (
        <div className="hciContent">
            <h1 className="heading1">Soft Controls vs. Hard Controls</h1>
            <h2 className="heading2">CSI-400: Human Computer Interaction Research Project</h2>
            <p className="descriptionText">Examined the performance characteristics between touch-screen and hardware control interfaces</p>

            <div className="social-icons">
                <a target="_blank" href="https://www.linkedin.com/in/derisomalley/details/projects/"><i className='bx bxl-linkedin'></i></a>
                <a target="_blank" href="https://github.com/DerisO22/Soft-Control-Research-Project"><i className='bx bxl-github'></i></a>
            </div>

            {/* <!-- Example Images --> */}
            <h2 className="app_examples_header">From The Project</h2>

            <div className="imageExampleContainerHCI">
                <div className="image1_container">
                    <img className="example_image1" src="/hci_assets/soft_control_Interface.webp" alt="Phonici Loading Screen"></img>
                    <div className="phonici_example1_overlay">
                        <div className="overlay_text">Soft Control Interface Web Page Using An Ipad Mini</div>
                    </div>
                </div>
                <div className="image2_container">
                    <img className="example_image2" src="/hci_assets/hard_control_Interface.webp" alt="Hard C"></img>
                    <div className="phonici_example2_overlay">
                        <div className="overlay_text">Hard Control Interface Using Arduino Micro-Controller</div>
                    </div>
                </div>
            </div>
        </div>  
    )
}

export default HCI;
